export default "__VITE_ASSET__DBEgRPOJ__"